import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { base64StringToBlob } from 'blob-util';
import Swal from 'sweetalert2';
import useFetch from '../../hooks/useFetch';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

//
function FotosHistoricasDropzone(props) {
    const { del } = useFetch();
    // props recebe os parâmetros do componente pai (Item.js) quando faz <ImageDropzone (parâmetros) />
    const fotosHistoricasAdicionadas = props.fotosHistoricasAdicionadas;
    const [files, setFiles] = useState(() => {
        let fotosHistoricas = { salvas: [], adicionadas: [] };
        if (props.acao !== "Criar") {
            if (Array.isArray(props.fotosHistoricasSalvas) && props.fotosHistoricasSalvas.length > 0) {
                for (const file of props.fotosHistoricasSalvas) {
                    let blobImage = base64StringToBlob(file.base64, 'image/png');
                    fotosHistoricas.salvas.push({
                        ...file,
                        value: blobImage,
                        preview: URL.createObjectURL(blobImage),
                        descricao: file.descricao
                    });
                }
            }
        } return fotosHistoricas;
    });

    const { getRootProps, getInputProps } = useDropzone({
        disabled: props.disabled,
        accept: {
            'image/*': []
        },
        onDrop: acceptedFiles => {
            (async () => {
                let imagensCarregadas = [];
                for (const file of acceptedFiles) {
                    let readFile = await readFileData(file);
                    imagensCarregadas.push({
                        value: file,
                        preview: URL.createObjectURL(file),
                        descricao: "",
                        editada: false
                    });
                    let imagensAtualizadas = {
                        salvas: [...files.salvas],
                        adicionadas: [...files.adicionadas, ...imagensCarregadas]
                    };
                    setFiles(imagensAtualizadas);
                    fotosHistoricasAdicionadas(imagensAtualizadas); // Passando o valor para o componente pai (Item.js)
                }
            })();
        }
    });

    const readFileData = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async () => {
            resolve(reader.result);
        };
        reader.onerror = function () {
            reject(reader.error);
        };
        reader.readAsBinaryString(file);
    });

    const changeDescricaoAdicionada = (index, value) => {
        let imagensAtualizadas = {};
        let adicionadas = [...files.adicionadas];
        let foto = adicionadas[index];
        foto.descricao = value;
        imagensAtualizadas = {
            salvas: [...files.salvas],
            adicionadas: adicionadas
        };
        setFiles(imagensAtualizadas);
        fotosHistoricasAdicionadas(imagensAtualizadas); // Passando o valor para o componente pai (Item.js)
    }

    const changeDescricaoSalva = (index, value) => {
        let imagensAtualizadas = {};
        let salvas = [...files.salvas];
        let foto = salvas[index];
        foto.descricao = value;
        foto.editada = true;
        imagensAtualizadas = {
            salvas: salvas,
            adicionadas: [...files.adicionadas]
        };
        setFiles(imagensAtualizadas);
        fotosHistoricasAdicionadas(imagensAtualizadas); // Passando o valor para o componente pai (Item.js)
    }

    const excluirFotoAdicionada = (index) => {
        let fotosAdicionadas = [...files.adicionadas];
        fotosAdicionadas.splice(index, 1);
        let imagensAtualizadas = {
            salvas: [...files.salvas],
            adicionadas: fotosAdicionadas
        }
        setFiles(imagensAtualizadas);
        fotosHistoricasAdicionadas(imagensAtualizadas); // Passando o valor para o componente pai (Item.js)
    }

    const excluirImagemSalva = (index) => {
        let imagensAtualizadas = {};
        Swal.fire({
            title: 'Deseja excluir a imagem?',
            text: "Esta ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Excluir a imagem do banco de dados
                let foto = files.salvas[index];
                let result = await del(`/fotohistorica/${foto.id_item}/${foto.sec_fotohistorica}`);

                if (result.error) {
                    Swal.fire(
                        'Erro!',
                        result.message,
                        'error'
                    );
                    return;
                }

                let fotosSalvas = [...files.salvas];
                fotosSalvas.splice(index, 1);
                imagensAtualizadas = {
                    salvas: fotosSalvas,
                    adicionadas: [...files.adicionadas]
                }
                setFiles(imagensAtualizadas);
                fotosHistoricasAdicionadas(imagensAtualizadas); // Passando o valor para o componente pai (Item.js)

                Swal.fire(
                    'Imagem excluída!',
                    'A imagem foi excluída com sucesso.',
                    'success'
                );
            }
        });
    }

    const thumbsSalvas = files.salvas.map((file, index) => (
        <div className="row mt-2" key={index}>
            <div className="col-sm-2">
                <div style={thumb} key={index}>
                    <div style={thumbInner} key={index}>
                        <img
                            key={index}
                            src={file.preview}
                            style={img}
                            alt={"Imagem"}
                            // Revoke data uri after image is loaded
                            onLoad={() => { URL.revokeObjectURL(file.preview) }}
                        />
                    </div>
                </div>
            </div>
            <div className="col-sm-2 col-md-8" key={index}>
                <div className="form-group mt-2" key={index}>
                    <label htmlFor={"desc_foto" + index} className="form-label">Descrição</label>
                    <input
                        type="text"
                        id={"desc_foto" + index}
                        className="form-control"
                        name="desc_foto"
                        placeholder="Descrição da foto"
                        value-id={index}
                        value={file.descricao ?? ""}
                        onChange={(e) => {
                            changeDescricaoSalva(index, e.target.value);
                        }}
                        maxLength={400}
                    />
                </div>
            </div>
            <div className="col-auto align-self-center mt-2" style={{'cursor': 'pointer'}}>
                {
                    props.acao !== "Visualizar" ?
                        <FontAwesomeIcon
                            icon={faX}
                            onClick={() => excluirImagemSalva(index)}>
                        </FontAwesomeIcon>
                        : null
                }
            </div>
            <hr className="m-2"></hr>
        </div>
    )) ?? null;

    const thumbsAdicionadas = files.adicionadas.map((file, index) => (
        <div className="row mt-2" key={index}>
            <div className="col-sm-2">
                <div style={thumb} key={index}>
                    <div style={thumbInner} key={index}>
                        <img
                            key={index}
                            src={file.preview}
                            style={img}
                            alt={"Imagem"}
                            // Revoke data uri after image is loaded
                            onLoad={() => { URL.revokeObjectURL(file.preview) }}
                        />
                    </div>
                </div>
            </div>
            <div className="col-sm-2 col-md-8" key={index}>
                <div className="form-group mt-2" key={index}>
                    <label htmlFor={"desc_foto" + index} className="form-label">Descrição</label>
                    <input
                        type="text"
                        id={"desc_foto" + index}
                        className="form-control"
                        name="desc_foto"
                        placeholder="Descrição da foto"
                        value-id={index}
                        value={file.descricao ?? ""}
                        onChange={(e) => {
                            changeDescricaoAdicionada(index, e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="col-auto align-self-center mt-2" style={{'cursor': 'pointer'}}>
                {
                    props.acao !== "Visualizar" ?
                        <FontAwesomeIcon
                            icon={faX}
                            onClick={() => excluirFotoAdicionada(index)}
                            >
                        </FontAwesomeIcon>
                        : null
                }
            </div>
            <hr className="m-2"></hr>
        </div>
    )) ?? null;

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => {
            if (!files)
                return null;
            files.salvas.forEach(file => URL.revokeObjectURL(file.preview))
            files.adicionadas.forEach(file => URL.revokeObjectURL(file.preview))
        }
    }, []);

    return (
        <section className="container-fluid p-0">
            <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <div className="p-5 bg-light">Arraste as imagens para cá ou clique aqui para selecionar</div>
            </div>
            <aside className="row" style={thumbsContainer}>
                {thumbsSalvas}
                {thumbsAdicionadas}
            </aside>
        </section>
    );
}

export default FotosHistoricasDropzone;